<template>
  <span v-if="props.status === 0" class="badge bg-info"><font-awesome-icon :icon="['fas', 'hourglass-end']" fixed-width /> {{ $t('status.pending') }}</span>
  <span v-else-if="props.status === 1" class="badge bg-warning text-dark"><font-awesome-icon :icon="['fas', 'truck']" fixed-width /> {{ $t('status.inProgress') }}</span>
  <span v-else-if="props.status === 2" class="badge bg-success"><font-awesome-icon :icon="['fas', 'check']" fixed-width /> {{ $t('status.completed') }}</span>
  <span v-else-if="props.status === 3" class="badge bg-danger"><font-awesome-icon :icon="['fas', 'xmark']" fixed-width /> {{ $t('status.cancelled') }}</span>
  <span v-else class="badge bg-danger"><font-awesome-icon :icon="['fas', 'trash']" fixed-width /> {{ $t('status.failed') }}</span>
</template>

<script setup lang="ts">
const props = defineProps({
  status: { type: Number, required: true }
});
</script>
